<template>
  <el-form class="form-complaint" :model="form" ref="complaint" :rules="rules" :disabled="disabled">
    <p class="title">权利投诉单</p>
    <el-row :gutter="10" type="flex" class="one-info info">
      <el-col :span="3">
        <el-form-item class="name">
          权利主张人的主体名称
          <el-tooltip class="tooltip" effect="dark" :content="nameTip">
            <img src="@/assets/complaint/question.png" class="icon-question"/>
          </el-tooltip>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item class="identity">
          身份证明
          <el-tooltip class="tooltip" effect="dark" :content="identityTip">
            <img src="@/assets/complaint/question.png" class="icon-question"/>
          </el-tooltip>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="identity">
          <el-input v-model="form.identity"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" class="two-info info">
      <el-col :span="3">
        <el-form-item class="phone">
          移动电话
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="phone">
          <el-input v-model="form.phone"/>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item class="other">
          联系微信/QQ/邮箱
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="other">
          <el-input v-model="form.other"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" class="three-info info">
      <el-col :span="3">
        <el-form-item class="question">
          权利主张人诉求
        </el-form-item>
      </el-col>
      <el-col :span="17">
        <el-form-item prop="question">
          <el-input type="textarea" v-model="form.question"/>
        </el-form-item>
      </el-col>   
    </el-row>
    <template v-for="(prove,index) in form.proves">
      <div class="prove">
        <div class="delete" >
          <div class="delete-button" @click="deleteProve(index)">
            <i class="el-icon-minus"></i>
            移除
          </div>
        </div>
        <el-row :gutter="10" type="flex" class="four-info info">
          <el-col :span="3" class="col-title">
            主张权利的图片截图
          </el-col>
          <el-col :span="6">
            <el-upload
              ref="uploadImage"
              action="http://upload.qiniup.com/"
              :auto-upload="false"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="(file,fileList) => changeUpload(file, fileList ,'uploadImage',index)"
              :http-request="(req) => uploadImageQiNiu(req,index,'img_file')"
              class="avatar-uploader">
              <img v-if="prove['img_file']" :src="prove['img_file']" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
          <el-col :span="3" class="col-title">
            主张权利图片截图的证明权益材料
            <el-tooltip class="tooltip" effect="dark" :content="proofTip">
              <img src="@/assets/complaint/question.png" class="icon-question"/>
            </el-tooltip>
          </el-col>
          <el-col :span="12">
            <div class="proves-file">
              <el-upload
                ref="uploadProve"
                action="http://upload.qiniup.com/"
                :auto-upload="false"
                list-type="picture-card"
                :show-file-list="false"
                :on-change="(file,fileList) => changeUpload(file, fileList, 'uploadProve',index)"
                :http-request="(req) => uploadImageQiNiu(req,index,'proof_file')"
                class="avatar-uploader"
                >
                <img v-if="prove['proof_file']" :src="prove['proof_file']" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-input type="textarea" class="proves-text" placeholder="请填写文本证明材料" v-model="prove['proof_text']"/>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
    <div class="add" @click="addProve">
      <div class="add-button">
        <i class="el-icon-plus"></i>
      </div>
      还有其他的主张权利图片截图
    </div>
    <div class="submit">
      <el-button type="primary" @click="submitData" medium>提交</el-button>
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import Qiniu from 'qiniu-js'

// axios.defaults.withCredentials = true

export default {
  name: 'Complaint',
  data() {
    let checkPhone =(rule, value, callback) => {
      if(!value) {
        this.$message.error({
          message: '手机号不能为空'
        })
        return 
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
            callback();
          } else {
            this.$message.error({
              message: '请输入正确手机号'
            })
            return 
          }
      }
    }
    return {
      nameTip: '此处可为个人，组织或公司等',
      identityTip: `个人身份证明：不限于对应权利主张人主体名称的身份证号驾驶证号护照号等
组织/公司证明：不限于对应权利主张人主体名称的营业执照编号等`,
      proofTip: '图片著作权证书，网站发布链接（微博，zcool，behance等）或其他证明材料。',
      disabled: false,
      form: {
        name: '',
        identity: '',
        phone: '',
        other: '',
        question: '',
        note: '',
        proves: [
         {
          img_file:'',
          proof_file: '',
          proof_text: ''
         }
        ],
      },
      rules: {
        name: [
          { required: true, message: '请输入权利主张人的主体名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请输入身份证明', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: checkPhone,  trigger: 'blur' }
        ],
        other: [
          { required: true, message: '请输入其他联系方式', trigger: 'blur' }
        ],
        question: [
          { required: true, message: '请输入诉求', trigger: 'blur' }
        ]
      },
      data: {
        upload_token: '',
        key: ''
      }
    }
  },
  methods: {
    submitData() {
      const imageCheck = this.checkImage()
      if(imageCheck) {
        this.$message.error({
          message: '请填写文本证明材料或者上传图片证明'
        })
        return 
      }
      this.$refs.complaint.validate((valid) => {
        if(valid&&!imageCheck) {
          this.disabled = true
          axios.post('/cfapi/v1/feedback',{
              feedback_name: this.form.name,
              feedback_id_number: this.form.identity,
              feedback_phone: this.form.phone,
              feedback_contact: this.form.other,
              feedback_appeal: this.form.question,
              feedback_details: this.form.proves
          }).then((res)=>{
            this.$router.push('/success')
          }).catch((err) => {
            this.$message.error({
              message: err.message
            })
            this.disabled = false
          })
        }else {
          this.$message.error('内容填写错误或者未填写部分内容')
          this.disabled = false
          return false
        }
      })
    },
    changeUpload(file,fileList, refs,index) {
      axios.get(`/cfapi/v1/feedback/upload_token?ext=${file.raw.type.substring(file.raw.type.lastIndexOf('/') + 1)}`).then((res)=>{
        this.data['upload_token'] = res.data.data.token
        this.data['key'] = res.data.data.key
        this.$refs[refs][index].submit()
      }).catch((err) => {
        this.$message.error({
          message: err.message
        })
      }).finally(() => {
        this.$refs[refs][index].clearFiles()
      })
    },
    uploadImageQiNiu(req, index, imgName) {
      let formData = new FormData()
      let config= {
        'Content-Type': 'multipart/form-data'
      }
      formData.append('file', req.file)
      formData.append('key', this.data['key'])
      formData.append('token', this.data['upload_token'])

      axios.post('https://upload-z1.qiniup.com/', formData, config)
        .then((res) => {
          let imgUrl = `https://cdn.learnings.com.cn/${res.data.key}`
          this.form.proves[index][imgName] = imgUrl
        }).catch((err) => {
          this.$message.error({
            message: err.message
          })
        })
      },
    addProve() {
      this.form.proves.push({
        img_file:'',
        proof_file: '',
        proof_text: ''
      })
    },
    deleteProve(index) {
      if(this.form.proves.length <=1){
        this.$message.error({
          message: '必须上传至少一份证明材料'
        })
      }else {
        this.form.proves.splice(index,1)
      }
    },
    checkImage() {
      const isCheck = this.form.proves.some(ele => {
        return !(ele.proof_file || ele.proof_text)
      })
      return isCheck
    }
  }
}
</script>

<style scoped>
.form-complaint{
  padding:10px 80px;
  text-align: center;
}
.title{
  font-size:30px;
  text-align: center;
}

.icon-question{
  width:18px;
  height:18px;
}
.info{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:20px;
}

.four-info{
  padding-left:50px;
  padding-right:50px;
}
.submit{
  margin-top:50px;
}
.add{
  display: flex;
  justify-content: center;
  align-items: center;
  border:2px dashed #ccc;
  height:40px;
  border-radius: 5px;
  margin:50px;
  margin-top:20px;
}
.add-button{
  width:30px;
  height:30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:20px;
  margin-right:20px;
}
.delete{
  height:20px;
  font-size:15px;
  padding-right:50px;
  display: flex;
  flex-direction: row-reverse;
  margin-top:20px;
  background:#eee;
  margin:20px 50px;
}

.delete-button{
  width:100px;
}
.proves-text{
  margin-top: 20px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
  .col-title{
    font-size:18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Complaint.vue